var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_1466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 12,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3354 1.05093C14.7953 1.4984 14.7953 2.22388 14.3354 2.67135L7.3172 9.49985L14.3354 16.3284C14.7953 16.7758 14.7953 17.5013 14.3354 17.9488C13.8755 18.3962 13.1299 18.3962 12.67 17.9488L3.98633 9.49985L12.67 1.05093C13.1299 0.603466 13.8755 0.603466 14.3354 1.05093Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_1466)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.167114,
    y: 0.331787,
    width: 18.3326,
    height: 18.3329,
    fill: "#B2B2B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftGrey);
export default __webpack_public_path__ + "static/media/left_grey.f4b7de6ea2e573ec762284e4f073b991.svg";
export { ForwardRef as ReactComponent };